// extracted by mini-css-extract-plugin
module.exports = {"upgradeWidgetContainer":"UpgradeWidget_upgradeWidgetContainer__9Mg4r","upgradeWidget":"UpgradeWidget_upgradeWidget__zRBuS"};